import { render } from "./AxisBottom.vue?vue&type=template&id=46251066"
import script from "./AxisBottom.vue?vue&type=script&lang=js"
export * from "./AxisBottom.vue?vue&type=script&lang=js"
script.render = render

export default script